export const PMEndingTitle = () => {
  return (
    <>
      성장하는 PM이 되는 길,
      <br />
      지금 바로 시작하세요.
    </>
  );
};

export const MktEndingTitle = () => {
  return (
    <>
      3개월이면 충분합니다,
      <br />
      데이터로 소통하는 <br className={"mk-mo"} />
      마케터가 되세요.
    </>
  );
};
